import {
  ApprovalStatusEnum,
  ItemManagementType,
  RateSettingType,
  SubcontractorStatusEnum,
  SubcontractorType,
  UIConfig,
  UserType,
} from '../enum';

export const WS_REGISTER_ROUTE = '/websocket/';
export const WS_SOCKET = import.meta.env.VITE_SOCKET_URL + WS_REGISTER_ROUTE;
export const SHORT_DATE_FORMAT_API = 'YYYY-MM-DD';
export const LONG_DATE_FORMAT_API = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const SHORT_DATE_FORMAT = 'DD/MM/YYYY';
export const LONG_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const VALUE_EMPTY_TABLE = '—';

export const SORT_KEYS = {
  ascend: 'asc',
  descend: 'desc',
};

export const STATES = [
  {
    label: 'Queensland',
    value: 'Queensland',
  },
  {
    label: 'Tasmania',
    value: 'Tasmania',
  },
  {
    label: 'New South Wales',
    value: 'NewSouthWales',
  },
  {
    label: 'Victoria',
    value: 'Victoria',
  },
  {
    label: 'Western Australia',
    value: 'WesternAustralia',
  },
  {
    label: 'South Australia',
    value: 'SouthAustralia',
  },
  {
    label: 'Northern Territory',
    value: 'NorthernTerritory',
  },
  {
    label: 'Australian Capital Territory',
    value: 'AustralianCapitalTerritory',
  },
];

export const USER_TYPE_OPTIONS = [
  {
    value: UserType.Office,
    label: 'Office',
  },
  {
    value: UserType.Subcontractor,
    label: 'Subcontractor',
  },
  {
    value: UserType.Production,
    label: 'Production',
  },
  {
    value: UserType.Engineering,
    label: 'Engineering',
  },
];

export const SUBCONTRACTOR_SUB_PATH = {
  [SubcontractorType.All]: '',
  [SubcontractorType.LaserCutting]: 'LaserCutting',
  [SubcontractorType.InsulationCutting]: 'InsulationCutting',
  [SubcontractorType.RollForming]: 'RollForming',
  [SubcontractorType.Folding]: 'Folding',
};

export const SUBCONTRACTOR_FILTER_TYPE = {
  [SubcontractorType.All]: UIConfig.SubcontractorAll,
  [SubcontractorType.LaserCutting]: UIConfig.SubcontractorLaserCutting,
  [SubcontractorType.InsulationCutting]: UIConfig.SubcontractorInsulation,
  [SubcontractorType.RollForming]: UIConfig.SubcontractorRollForming,
  [SubcontractorType.Folding]: UIConfig.SubcontractorFolding,
};

export const SUBCONTRACTOR_DETAIL_TITLE = {
  [SubcontractorType.All]: '',
  [SubcontractorType.LaserCutting]: 'Laser Cutting',
  [SubcontractorType.InsulationCutting]: 'Insulation Cutting',
  [SubcontractorType.RollForming]: 'Roll-forming',
  [SubcontractorType.Folding]: 'Folding',
};

export const ITEMS_UNIT_PATH = {
  [ItemManagementType.ImportDate]: 'ItemImportDate',
  [ItemManagementType.QCDate]: 'ItemQCDate',
  [ItemManagementType.DeliveredDate]: 'ItemDeliveredDate',
};

export const ITEMS_FILTER_TYPE = {
  [ItemManagementType.ImportDate]: UIConfig.ItemImportDate,
  [ItemManagementType.QCDate]: UIConfig.ItemQCDate,
  [ItemManagementType.DeliveredDate]: UIConfig.ItemDeliveredDate,
};

export const SUBCONTRACTOR_STATUS_OPTIONS = [
  {
    value: SubcontractorStatusEnum.Pending,
    key: SubcontractorStatusEnum.Pending,
    label: 'Pending',
  },
  {
    value: SubcontractorStatusEnum.Released,
    key: SubcontractorStatusEnum.Released,
    label: 'Released',
  },
  {
    value: SubcontractorStatusEnum.InProgress,
    key: SubcontractorStatusEnum.InProgress,
    label: 'In Progress',
  },
  {
    value: SubcontractorStatusEnum.Done,
    key: SubcontractorStatusEnum.Done,
    label: 'Done',
  },
];

export const TRANSLATION_FIELD_VALUES = [
  'hasStarted',
  'hasFinished',
  'hasTransferred',
  'hasApproved',
  'hasPaid',
  'hasSubcontracted',
  'status',
  'laserStatus',
  'insulationStatus',
  'rollFormingStatus',
  'foldingStatus',
  'deliveredVerify',
  'qcVerify',
];

export const APPROVAL_STATUS_OPTIONS = [
  {
    value: ApprovalStatusEnum.Pending,
    key: ApprovalStatusEnum.Pending,
    label: 'Pending',
  },
  {
    value: ApprovalStatusEnum.Approved,
    key: ApprovalStatusEnum.Approved,
    label: 'Approved',
  },
  {
    value: ApprovalStatusEnum.Rejected,
    key: ApprovalStatusEnum.Rejected,
    label: 'Rejected',
  },
];

export const RATE_SETTING_TYPE_OPTIONS = [
  {
    value: RateSettingType.ItemFault,
    label: 'Item Fault Labour Rate',
  },
  {
    value: RateSettingType.ProductionFault,
    label: 'Production Fault Labour Rate',
  },
  {
    value: RateSettingType.LaserCutting,
    label: 'Laser Cutting Rate',
  },
  {
    value: RateSettingType.InsulationCutting,
    label: 'Insulation Cutting Rate',
  },
  {
    value: RateSettingType.RollForming,
    label: 'Roll-forming Rate',
  },
  {
    value: RateSettingType.Folding,
    label: 'Folding Rate',
  },
];

export const LEVEL_OPTIONS = [
  {
    key: '1',
    label: 'Level 1',
  },
  {
    key: '2',
    label: 'Level 2',
  },
  {
    key: '3',
    label: 'Level 3',
  },
  {
    key: '4',
    label: 'Level 4',
  },
  {
    key: '5',
    label: 'Level 5',
  },
];

export const CONFIG_FILTER_DEFAULT = [
  {
    name: 'jobIds',
    span: 6,
    label: 'Job ID',
  },
  {
    name: 'parts',
    span: 6,
    label: 'Part',
  },
  {
    name: 'actions',
    span: 6,
    label: 'Action',
  },
  {
    name: 'names',
    span: 6,
    label: 'Name',
  },
];
